import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import { SHOP_TIRES_TAB_NAME, NEED_HELP_TAB_NAME } from '../../constant'

const Tabs = ({ tab, setTabHandler = () => {} }) =>
  <Wrapper>
    <Tab
      aria-label={ tab === SHOP_TIRES_TAB_NAME ? 'Active shop by tire size tab' : 'Inactive shop by tire size tab' }
      active={ tab === SHOP_TIRES_TAB_NAME }
      onClick={ () => setTabHandler(SHOP_TIRES_TAB_NAME) }>
      { SHOP_TIRES_TAB_NAME }
    </Tab>
    <Tab
      aria-label={ tab === NEED_HELP_TAB_NAME ? 'Active need help tab' : 'Inactive need help tab' }
      active={ tab === NEED_HELP_TAB_NAME }
      onClick={ () => setTabHandler(NEED_HELP_TAB_NAME) }>
      { NEED_HELP_TAB_NAME }
    </Tab>
  </Wrapper>


export default Tabs

Tabs.propTypes = {
  setTabHandler: PropTypes.func,
  tab: PropTypes.string
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #d7d7d7;
  margin-bottom: 32px;
  ${Media.mobile`
    justify-content: center;
  `}
`

const Tab = styled.button`
  text-transform: uppercase;
  ${Mixin.font.GothamBook(16)};
  color: ${Theme.colors.black_new};
  padding: 0 20px 8px;
  cursor: pointer;
  border: none;
  display: flex;
  align-items: center;
  position: relative;
  background: transparent;

  &::after {
    background-color: ${Theme.colors.transparent};
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    content: "";
    width: 100%;
    height: 2px;
    display: block;
  }

  ${props => props.active && css`
    color: ${Theme.colors.bright_red_new};
    ${Mixin.font.GothamBold(16)};

    &::after {
      background-color: ${Theme.colors.bright_red_new};
    }
  `}

  @media (max-width: 400px) {
    ${Mixin.font.GothamBook(12)};
  }
`
